import { render } from "./SelectInputSearch.vue?vue&type=template&id=0bdc7d1e"
import script from "./SelectInputSearch.vue?vue&type=script&lang=js"
export * from "./SelectInputSearch.vue?vue&type=script&lang=js"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__